import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import "./App.css";
import "./App.scss";
import { createBrowserHistory } from "history";
import Game from "./component/Game";
import Rules from "./page/Rules";
import Login from "./page/Login";
import { socket } from "./component/soket";
import useStore from "./store";
import NextLevel from "./component/NextLevel";
import strings from "./lang/Localiz";
import StatusGame from "./component/StatusGame";
import Header from "./component/Header";
import Settings from "./page/Settings";

const customHistory = createBrowserHistory({
  // basename: config.urlBasename || ""
});

function App() {
  const lang = useStore((state) => state.lang);
  const loggedIn = useStore((state) => state.loggedIn);
  const gameOver = useStore((state) => state.gameOver);
  const token = localStorage.getItem("token");
  const modalError = useStore((state) => state.modalError);
  const modalEndGame = useStore((state) => state.modalEndGame);
  const readInfo = useStore((state) => state.readInfo);


  function InitialGame() {
    const sToken = useStore((state) => state.token);
    const token = localStorage.getItem("token")
      ? localStorage.getItem("token")
      : sToken
      ? sToken
      : false;
    const initGame = useStore((state) => state.initGame);
    const urlAuthToken = new URLSearchParams(window.location.search).get(
      "auth_token"
    );
    const getUser = useStore((state) => state.getUser);

    useEffect(() => {
      if (urlAuthToken) {
        socket.emit("token_login", { token: urlAuthToken });
        socket.on("login", (data) => {
          if (!data) return;
          if (data.error) return
          getUser(data);
          emitInit(data.token);
        });
      } else if (token) {
        emitInit();
      }

      function emitInit(tokenPassed) {
        const initData = {
          token: tokenPassed ? tokenPassed : token,
        };
        socket.emit("init", initData);
        socket.on("init", (data) => {
          if (data.error) {
            modalError(data.error);
            if (data.error === "GAME_EXPECTATION") {
              localStorage.removeItem("token");
              window.location.reload();
            }
          } else {
            if (data.soon) {
              modalError("cheat");
            } else if (data.endgame === true) {
              modalEndGame(data);
            } else {
              initGame(data);
            }
          }
        });
      }
      return () => {
        socket.off("init");
        socket.off("login");
      };
    }, []);
    return null;
  }

  strings.setLanguage(lang);


  return (
    <Router history={customHistory}>
      <StatusGame />
      <InitialGame />
      <NextLevel />

      <Header />

      <Route exact path="/">
        {readInfo ? (
          token && !gameOver) || (loggedIn && !gameOver) ? (
            <Redirect
              to={`/game${window.location.search ? window.location.search : ""}`}
            />
          ) : (
            <Login />
          ) : (
            <Redirect
              to={`/rules${window.location.search ? window.location.search : ""}`}
            />
        )}
        
      </Route>
      <Route exact path="/game">
        {readInfo ? (
           token && !gameOver) || (loggedIn && !gameOver) ? (
            <Game />
          ) : (
            <Redirect
              to={`/${window.location.search ? window.location.search : ""}`}
            />
          ) : (
            <Redirect
              to={`/rules${window.location.search ? window.location.search : ""}`}
            />
        )}
      </Route>

      <Route exact path="/rules" component={Rules} />
      <Route exact path="/admin" component={Settings} />
    </Router>
  );
}

export default App;
